module.exports = require('./dist/BackgroundImage.js');



//////////////////
// WEBPACK FOOTER
// ./~/react-background-image-loader/index.js
// module id = 36
// module chunks = 168707334958949